export interface AxiosResponse {
    data: any;
    status: number | string;
    message: string;
}

export interface SaleAngle {
    name: string,
    description: string,
    complementary_angles?: string[]
}

export interface FunnelPayload {
    products: any[],
    brand_name: string,
    brand_id?: string | null,
    brand_context?: Record<string, any> | null,
    sale_angles: SaleAngle[],
    free_shipping: boolean,
    country_code?: string,
    currency_code?: string,
    warranties: number,
    template_design: {
        theme: string,
        primary_color: string,
        secondary_color: string,
        template_name?: string,
        cover_style?: string,
        style_sheet?: string,
        palette?: string,
        template_family?: string,
    },
    data_for_context: any,
    is_custom_sections_only?: boolean
}

// Multi-funnel payload (Flow B) — POST /websites/bulk
export interface TemplatePage {
    id: string;
    name: string;
    type: string;
    sort: number;
    page: string;
    runtime?: 'template_studio' | 'legacy_react';
    renderer?: 'html' | 'image' | 'react';
    source?: string;
    metadata?: Record<string, any>;
}

export interface PromotionPayload {
    enabled: boolean;
    type: 'discount' | 'buy_x_get_y' | 'combo';
    label: string;
    limitTime: boolean;
    timeLimit?: 'unlimited' | 'midnight' | '60min' | '10min';
    discountPercentage?: number;
    paidUnits?: number;
    receivedUnits?: number;
}

export interface MultiFunnelItem {
    brand_name: string;
    name_funnel?: string;
    brand_id?: string | null;
    brand_context?: Record<string, any> | null;
    sale_angles: SaleAngle[];
    free_shipping: boolean;
    country_code?: string;
    currency_code?: string;
    warranties: number;
    template_structure?: {
        template_pages: TemplatePage[];
    };
    template_design?: {
        theme: string;
        primary_color: string;
        secondary_color: string;
        template_name?: string;
        cover_style?: string;
        style_sheet?: string;
        palette?: string;
        template_family?: string;
    };
    is_custom_sections_only?: boolean;
    promotion?: PromotionPayload | null;
}

export interface MultiFunnelProduct {
    product_id?: string | null;
    external_id: string | null;
    provider_id: string | null;
    name: string;
    description: string;
    price: number;
    offer_price?: number;
    effective_price?: number;
    country_code?: string;
    currency_code?: string;
    offer_country_code?: string;
    offer_currency_code?: string;
    url_images: string[];
    images?: string[];
    type: 'PRINCIPAL' | 'UP_SELL' | 'BUMP_OFFER';
    variants?: any;
}

export interface MultiFunnelPayload {
    client_request_id?: string;
    products: MultiFunnelProduct[];
    funnels: MultiFunnelItem[];
    data_for_context: {
        pain_detection: string;
        buyer_detection: string;
        recommended_sales_angles: SaleAngle[];
        // Optional free-form text the user typed in the onboarding "Add context" textarea.
        // Persisted by ecommerce on Website.dataForContext, then elevated by
        // TemplateStudioSectionDispatcher into each section's
        // parameters["additional_instructions"], which CE consumes as
        // request.user_instructions in both section_html_service and section_image_service.
        // See fix #6 (2026-05-19).
        additional_user_instructions?: string;
        product_variant_visual_context?: {
            summary: string;
            variations: string[];
            visual_references: Array<{
                variation_name: string;
                image_url: string;
                attribute_name?: string;
                attribute_value?: string;
            }>;
        };
    };
}

export interface WebsiteCreditsEstimateResponse {
    website_count: number;
    base_credits: number;
    credits_per_website: number;
    video_reviews_gifs_pages: number;
    video_reviews_gifs_credits: number;
    credits_per_video_reviews_gifs_page: number;
    total_credits: number;
}

export interface AnalyticsFunnelPayload {
    owner_id: string;
    website_id: string;
    created_at: string;
}

export enum VideoStatus {
    INITIALIZING = "INITIALIZING",
    IN_PROGRESS = "IN_PROGRESS",
    DONE = "FINISHED",
    FAILED = "ERROR",
}
